<template>
	<div class="uif">
		<div class="uif__elm">
			<IconFilter />
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import IconFilter from "@/components/icons/IconFilter.vue";

@Options({
	components: { IconFilter },
})
export default class UiFilter extends Vue {}
</script>

<style scoped lang="scss">
.uif {
	&__elm {
	}
}
</style>
